/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from './Icon';
import FlexBox from './FlexBox';
import { COLORS, SHADOWS } from '../../styles/theme';
import { goBack } from '../../utils/navigation';
import { PAGE_HEADER_CLASS } from './Loader';

const OuterBoxCss: React.CSSProperties = {
  minHeight: "55px",
  width: "100vw",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  backgroundColor: COLORS.white,
  boxShadow: SHADOWS.sm,
  padding: "0 16px",
};

const BackButtonCss: React.CSSProperties = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  background: "#f4f4f4",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  cursor: "pointer",
};

const TitleTextCss = (hasDescription: boolean): React.CSSProperties => ({
  fontSize: hasDescription ? "17px" : "20px",
  fontWeight: hasDescription ? "700" : "600",
  color: COLORS.textPrimary,
  lineHeight: 1.2,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const DescriptionTextCss: React.CSSProperties = {
  fontSize: "11.5px",
  color: COLORS.textPlaceholder,
  marginTop: "2px",
  lineHeight: 1.3,
};

const BackHeaderBar: React.FC<{ title: string; description?: string; backLocation?: string; onClick?: () => void; rightActions?: React.ReactNode }>
  = ({ title, description, backLocation, onClick, rightActions }) => {

    const navigate = useNavigate();
    // `backLocation` is only the fallback for when there's no in-app history (deep link / push).
    const navigateToBack = () => goBack(navigate, backLocation);

    return (
      <FlexBox className={`theme-background ${PAGE_HEADER_CLASS}`} sx={{ ...OuterBoxCss }} gap={14} alignCenter={true}>
        <div
          style={BackButtonCss}
          onClick={onClick ? onClick : navigateToBack}
        >
          <ChevronLeft size={20} strokeWidth={1.75} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={TitleTextCss(!!description)}>
            {title}
          </div>
          {description && (
            <div style={DescriptionTextCss}>
              {description}
            </div>
          )}
        </div>
        {rightActions && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
            {rightActions}
          </div>
        )}
      </FlexBox>
    );
  };

export default BackHeaderBar;
